import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">漫画索引</h2>
          <p className="text-sm text-foreground-500 mb-8">按类别快速浏览妖精动漫全部漫画资源</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#index"
                className={`group flex items-center gap-4 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-accent-300 transition-all duration-300 cursor-pointer ${
                  i === 6 ? 'lg:col-span-3' : ''
                }`}
              >
                <div className="w-16 h-16 md:w-20 md:h-20 shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading={i >= 4 ? 'lazy' : undefined}
                    width={400}
                    height={300}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                </div>
                <span className="text-xs font-medium text-accent-600 bg-accent-100/80 px-2.5 py-1 rounded-full whitespace-nowrap shrink-0">
                  {item.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}